import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { KWELLO_ICON } from '../icon/KwelloSvgIcon';
import KwelloButton from 'common/components/KwelloButton/KwelloButton';
import './errorpage.scss';
import { APP_ROOT } from 'routes/routes.const';

function HomeButton() {
  const navigate = useNavigate();
  const returnHome = useCallback(() => {
    navigate(APP_ROOT);
  }, [navigate]);

  return (
    <KwelloButton
      themeColor="secondary"
      onClick={returnHome}
      icon={KWELLO_ICON.HOME_SOLID_ICON}
      size="large"
    >
      Return Home
    </KwelloButton>
  );
}

export default HomeButton;
